import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { mediaState } from '../atom';
import type { Media } from '../types';

export const useMediaListResponse = () => {
  const setMediaListFromRespone = useAtomCallback(
    useCallback((_get, set, data: Media[]) => {
      data.forEach((d) => {
        set(mediaState(d.id), d);
      });
    }, [])
  );

  return {
    setMediaListFromRespone,
  };
};
